export default __webpack_public_path__ + "static/media/2015_Ke_et_al_2015_NewPhytologist.9e1c5ffc.pdf";